import clsx from 'clsx';
import useCommentCard from '~/hooks/discussion/useCommentCard';
import { QuestionV2 } from '~/lib/discussions/types';
import useUser from '~/lib/user';
import { CommentV2Type } from '~/static/discussions/enums';
import { HelpfulButton } from '../HelpfulButton';
import { CreatorReply } from './CreatorReply';
import DiscussionOptions from './DiscussionOptions';
import DiscussionQuestionInfo from './DiscussionQuestionInfo';

function QuestionCard({
  question,
  partnersIds = [],
  mutateComment,
}: Readonly<{
  question: QuestionV2;
  partnersIds?: Array<number>;
  mutateComment?: () => void;
}>): JSX.Element {
  const {
    stateHelpfulCount,
    stateHasUserUpvoted,
    toggleVote,
    disableVoteBtn,
    creatorReply,
  } = useCommentCard(question, CommentV2Type.Question, partnersIds);

  const { user } = useUser();

  return (
    <div
      data-testid="questions-card-wrapper"
      className={clsx(
        'relative flex flex-col items-start gap-4 self-stretch rounded border border-gravel p-4 shadow-pdp',
        { 'pt-12': user?.id === question.user.id },
      )}
    >
      {/* Only owner can see options */}
      {user?.id === question.user.id && (
        <div className="absolute top-4 right-4 flex gap-3">
          <DiscussionOptions
            deleteUrl={`/api/v2/deals/${question.deal_id}/questions/${question.id}/`}
            discusstionType={CommentV2Type.Question}
            mutateComment={mutateComment}
          />
        </div>
      )}

      <DiscussionQuestionInfo
        comment={question.comment}
        userName={question.user.username}
        publishDate={new Date(question.created)}
        detailUrl={question.display_path}
      />

      {!!creatorReply && (
        <CreatorReply {...creatorReply} mutateComment={mutateComment} />
      )}

      <div className="flex items-center justify-center">
        <HelpfulButton
          helpfulCount={stateHelpfulCount}
          hasUserUpvoted={stateHasUserUpvoted}
          isDisabled={disableVoteBtn}
          onToggleVote={toggleVote}
        />
      </div>
    </div>
  );
}

export default QuestionCard;
